




















import { Vue, Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("notification/detail", {
      id: this.editId
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }

    this.spinLoading = false;
  }
}
